@if (loading$ | async) {
  <pr-loader></pr-loader>
}
<toasts [options]="notifOptions"></toasts>
<router-outlet></router-outlet>
<pr-form-container></pr-form-container>
<pr-notification-container></pr-notification-container>
<pwa-install-banner></pwa-install-banner>
<pwa-ios-install-sheet></pwa-ios-install-sheet>
<pwa-push-prompt></pwa-push-prompt>
<ea-env-border></ea-env-border>
